import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpService } from '../http.service';
import { SettingsService } from '../../settings/settings.service';

@Injectable({providedIn: 'root'})
export class UserAcceptCampaignProvider extends HttpService {

    /**
     * Serviço para obter contratos a serem assinados pelos usuários
     */
    constructor(http: HttpClient, settingsService: SettingsService) {
        super('userAcceptCampaign', http, settingsService);
    }

}
